import React from 'react';
import { useTranslations } from 'next-intl';
import { formatThousands } from '@wwe-portal/utils/format';
import { cn } from '@wwe-portal/ui/lib/lib';

interface WrestlerDetailsTableProps {
  details: any[];
  title: string;
}

const WrestlerDetailsTable: React.FC<WrestlerDetailsTableProps> = ({
  details,
  title,
}) => {
  const t = useTranslations();

  return (
    <div>
      <h4 className="my-[30px] text-xl">{t(title)}</h4>
      <div className="rounded-md bg-[#1f2138] p-5">
        <div className="mb-[15px] pl-[15px] pr-[15px]">
          <div className="flex">
            <div className="text-uppercase text-text700 w-[100px] min-w-[100px] text-xs font-semibold">
              {t('talent')}
            </div>
            <div className="text-uppercase text-text700 text-xs font-semibold">
              {t('buff')}
            </div>
          </div>
        </div>
        <div>
          {details.map((level, index) => {
            return level.text ? (
              <div
                key={`${level.talentScore}${index}`}
                className={cn('rounded-md p-[15px]', {
                  'bg-back400': index % 2 === 0,
                })}
              >
                <div className="flex items-center text-xs">
                  <div className="text-text500 flex w-[100px] min-w-[100px]">
                    {formatThousands(level.talentScore)}
                  </div>
                  <div className="text-text500 flex items-center">
                    {level.text}
                  </div>
                </div>
              </div>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

export default WrestlerDetailsTable;
